import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faild',
  templateUrl: './faild.component.html',
  styleUrls: ['./faild.component.css']
})
export class FaildComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
